<div class="chat-container page-content">
  <div class="chat-messages">
    <div style="text-align: center; justify-content: center; width: 100%;">
      <mat-divider class="divider"></mat-divider>
      <p class="date">{{ date | date:'d/M/yyyy, h:mm a' }}</p>
    </div>
    <div class="chat-message" *ngFor="let response of chatResponses; let i = index">
      <div class="row justify-content-end" *ngIf="response.sender == 'user'">
        <div class="chat-message-content chat-message-content-right col-5">
          <p class="chat-message-p-right">{{response.text}}</p>
        </div>
        <div class="icon col-1 text-center">
          <img [src]="photo" class="foto-icon" />
        </div>
      </div>
      <div class="row justify-content-start" *ngIf="response.sender == 'bot'">
        <div class="icon col-1 text-center">
          <img
            src="https://png.pngtree.com/png-vector/20191016/ourlarge/pngtree-cyborg-artificial-intelligence-vector-sign-icon-png-image_1803925.jpg"
            class="foto-icon" />
        </div>
        <div class="chat-message-content chat-message-content-left col-5">
          <p class="chat-message-p-left">{{response.text}}
            <br>
            <br *ngIf="response.context && response.showMore">
            <span *ngIf="response.context && response.showMore" [innerHTML]="response.context"></span>
            <br>
            <a href="#/forsker" (click)="response.showMore = !response.showMore"
              *ngIf="response.context && response.showMore == false">Ver más...</a>
            <a href="#/forsker" (click)="response.showMore = !response.showMore"
              *ngIf="response.context && response.showMore == true">Ver menos</a>
          </p>
        </div>
      </div>
      <div class="row justify-content-start" *ngIf="i == chatResponses.length - 1 && processing">
        <div class="icon col-1 text-center">
          <img
            src="https://png.pngtree.com/png-vector/20191016/ourlarge/pngtree-cyborg-artificial-intelligence-vector-sign-icon-png-image_1803925.jpg"
            class="foto-icon" />
        </div>
        <div class="chat-message-content chat-message-content-left col-5">
          <p class="chat-message-p-left"><mat-spinner></mat-spinner></p>
        </div>
      </div>
      <div></div>
      <div></div>
      <div></div>
    </div>
  </div>
  <div class="input-chat">
    <div class="app-footerx">
      <div class="wrap-emojis-main">
        <div class="contact-poll">
          <a class="icon-btn-contact-poll">
            <i class="fa fa-plus"></i>
          </a>
        </div>
        <input [disabled]="processing" type="text" class="input-emojis" [(ngModel)]="inputValue"
          (keyup.enter)="sendMessage()" placeholder="Escribe tu consulta aquí..." />
        <button [disabled]="inputValue == ''" [class.deactive]="inputValue == ''" class="send-button deactive"
          (click)="sendMessage()">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
            class="feather feather-send">
            <line x1="22" y1="2" x2="11" y2="13"></line>
            <polygon points="22 2 15 22 11 13 2 9 22 2"></polygon>
          </svg>
        </button>

      </div>
    </div>
  </div>
</div>